import { render } from "./GeoPage.vue?vue&type=template&id=12bb27bb&scoped=true"
import script from "./GeoPage.vue?vue&type=script&lang=js"
export * from "./GeoPage.vue?vue&type=script&lang=js"

import "./GeoPage.vue?vue&type=style&index=0&id=12bb27bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bb27bb"]])

export default __exports__